import React, { Component } from 'react';
import styled from 'styled-components';

import FlyingContainer from '../../components/FlyingContainer';
import { Subtitle } from '../../components/style';
import { secondaryFont } from 'react-components/dist/values/fonts/fonts';
import { dark, white } from 'react-components/dist/values/colors/colors';
import { Button } from 'react-components/dist/buttons/Button';

const Wrapper = styled.div`
  height: ${props => (props.first ? 90 : 70)}vh;
  position: relative;
  background-image: url(${props => props.backgroundImage});
  background-size: cover;
  background-position: center;
  z-index: 0;
  margin-bottom: 0;
  transition: 0.3s all;
`;

const Texts = styled.div`
    position: absolute;
    width: 100%;
    top: ${props => (props.first ? 60 : 45)}%;
    max-width: ${props => (props.opened ? '2000px' : '600px')};
    right: ${props => (props.right ? 0 : 'unset')}
    display: flex;
    justify-content: ${props => (props.right ? 'flex-end' : 'flex-start')};
    transition: 1s max-width;
`;

const Intro = styled.div`
  font: ${secondaryFont.large};
  color: ${white};
  display: ${props => (props.show ? 'block' : 'none')};
`;

const Content = styled.div`
  font: ${secondaryFont.large};
  color: ${white};
  display: ${props => (props.show ? 'block' : 'none')};
  & a {
    color: ${dark}!important;
    font-style: italic !important;
    text-decoration: none !important;
  }
  & figcaption {
    color: ${white}!important;
  }
  & video {
    width: 100%;
    outline: none;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: ${props => (props.right ? 'flex-start' : 'flex-end')};
  margin-top: 12px;
`;

class Post extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: this.props.active
    };
    this.content = React.createRef();
    this.flyingContainer = React.createRef();
    this.container = React.createRef();
  }

  togglePost = () => {
    this.setState({
      opened: !this.state.opened
    });
  };

  fixMarginBottom = () => {
    let wrapperBB = this.container.current.getBoundingClientRect();
    let flyingContainerBB = this.flyingContainer.current.getBoundingClientRect();

    let wrapperBottom = wrapperBB.top + wrapperBB.height;
    let flyingContainerBottom = flyingContainerBB.top + flyingContainerBB.height + 30;

    if (flyingContainerBottom > wrapperBottom)
      this.container.current.style.marginBottom = flyingContainerBottom - wrapperBottom + 'px';
    else this.container.current.style.marginBottom = 0 + 'px';
  };

  componentDidMount() {
    if (this.state.opened) {
      this.container.current.style.marginBottom = this.content.current.offsetHeight + 'px';
      let imgs = this.content.current.getElementsByTagName('img');
      for (let i = 0; i < imgs.length; i++) {
        imgs[i].addEventListener('load', () => {
          this.container.current.style.marginBottom = this.content.current.offsetHeight + 'px';
        });
      }
    } else {
      this.fixMarginBottom();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!this.state.opened) {
      this.fixMarginBottom();
      setTimeout(this.fixMarginBottom, 1010);
    } else {
      this.container.current.style.marginBottom = this.content.current.offsetHeight + 'px';
      setTimeout(() => {
        this.container.current.style.marginBottom = this.content.current.offsetHeight + 'px';
      }, 310);
      window.history.pushState(null, this.props.post.title, this.props.post.url);
      document.getElementById('langSwitcher').href = this.props.post.translation;
    }
  }

  render() {
    return (
      <Wrapper
first={this.props.index === 0}
backgroundImage={this.props.post.thumbnail}
ref={this.container}>
        <Texts
first={this.props.index === 0}
right={this.props.right}
opened={this.state.opened}>
          <FlyingContainer
containerRef={this.flyingContainer}
right={this.props.right}>
            <Subtitle
color={white}
text={this.props.post.title} />
            <Intro show={!this.state.opened}>{this.props.post.intro}</Intro>
            <Content
              ref={this.content}
              show={this.state.opened}
              dangerouslySetInnerHTML={{ __html: this.props.post.content }}
            />
            <ButtonContainer right={this.props.right}>
              <Button
                onClick={() => {
                  this.togglePost();
                }}
                dark
              >
                {this.state.opened ? 'Read Less' : 'Read More!'}
              </Button>
            </ButtonContainer>
          </FlyingContainer>
        </Texts>
      </Wrapper>
    );
  }
}

export default Post;
